import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'saas_remind',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tabListFlat: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      icon: '',
      rules: {
        title: [{
          required: true,
          message: '请输入组件名称',
          trigger: 'change'
        }, {
          max: 4,
          message: '组件名称长度最多4个字',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    var _this = this;
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_;
    var _ref = this.tabListFlat.find(function (i) {
        return i.key === _this.value.key;
      }) || {},
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? 'https://res.youlianfuwu.com/mini_program/shop/icon_saas_remind.jpg' : _ref$icon,
      _ref$config_default_v = _ref.config_default_value,
      config_default_value = _ref$config_default_v === void 0 ? {} : _ref$config_default_v;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({}, config_default_value), {}, {
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index
    }, this.value.config));
    this.icon = icon;
  }
};